import { IYourAppServer } from "../YourAppServer.service";
import Utils from "../../shared/utils";
import { Request, Response } from "../http.service";
import { appConfig } from "../../core-config";
import { StorageHive, LocalKeys } from "../valueStorage.service";
import { environment } from "../../../../environments/environment";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import {
  VersionModel,
  GetNewVersionModel,
} from "../../shared/models/version.model";

export interface ApiResponseData {
  DeserializeType(): void;
}

/** Response from YourAppServer API */
export class ApiResponse<T extends ApiResponseData> {
  private http_resp: Response = null;
  private classOfT: new () => T = null;
  private data: T = null;
  private isFlatResponse: boolean = false;

  /** Get Data from response */
  public get Data(): T {
    return this.data;
  }

  /** Was the request successfull */
  public get OK(): boolean {
    return this.http_resp.ok;
  }

  /** Get the HTTP Response */
  public get HttpResponse(): Response {
    return this.http_resp;
  }

  /** `isFlatResponse=true` for endpoints whose body is NOT `UappResponse`-wrapped (e.g. coupon redemption Reserve/Release/Confirm). */
  constructor(classOfT: new () => T, resp: Response, isFlatResponse: boolean = false) {
    this.http_resp = resp;
    this.classOfT = classOfT;
    this.isFlatResponse = isFlatResponse;
    this.ParseData();
  }

  private ParseData() {
    // when is all okay and has data, then parse it
    if (
      this.data === null &&
      this.http_resp.ok &&
      this.http_resp.body !== null
    ) {
      try {
        // todo in the moment i can nod read the properties of ts-modules and not sub elements
        const ObjOfT = new this.classOfT();
        // const PropertiesOfT: string[] = Object.getOwnPropertyNames(ObjOfT);
        const ResponseObject = this.isFlatResponse ? this.http_resp.body : this.http_resp.body.data;
        // const PropertiesOfResponse: string[] = Object.getOwnPropertyNames(ResponseObject);
        //// the class of generic T must have thers properties
        // if (PropertiesOfT.length === 0) {
        //  throw new Error(`Class '${ObjOfT.constructor.name}' has no properties. (Initialize there as null or undefined.)`);
        // }
        //
        //// check the response object has all needed properties
        // for (const property of PropertiesOfT) {
        //  const index = PropertiesOfResponse.indexOf(property);
        //  if (index > -1) {
        //    // remove the property, to check after for extra properties
        //    PropertiesOfResponse.splice(index, 1);
        //  } else {
        //    throw new Error(`Property '${property}' of '${ObjOfT.constructor.name}' not found in the Response '${this.http_resp.body.data_type}'`);
        //  }
        // }

        // use ObjOfT as base to keep the right ObjectType
        this.data = Utils.GetExtend(ObjOfT, ResponseObject);
        this.data.DeserializeType(); // es sollte auch alle seine member casten

        //// check Response has extra properties
        //if (PropertiesOfResponse.length > 0) {
        //  // only warn about extra properties
        //  console.warn(`Warning! Some properties in response '${this.http_resp.body.data_type}', but not in the object of '${ObjOfT.constructor.name}':`);
        //  console.warn(PropertiesOfResponse);
        //}
      } catch (error) {
        // set code to 422 when have some parsing error
        console.error(error);
        this.http_resp.ok = false;
        this.http_resp.code = 422;
        this.http_resp.codeText = "Unprocessable Entity";
      }
    }
  }
}

/** Connection to the YourAppServer API */
export class YourAppServerApi {
  public readonly MainPath: string = "api/";
  private _DeviceToken: string = null;

  constructor(public readonly YourAppServer: IYourAppServer) { }

  /**
   * Hilfsfunction zum absetzen von API calls.
   * `isFlatResponse`: set to true when the server sends the fields directly instead of inside `data`.
   */
  public RequestService<T extends ApiResponseData>(
    responseClass: new () => T,
    apiFunction: string,
    body: object = null,
    request: {
      params?: { [param: string]: string };
      headers?: { [header: string]: string };
    } = null,
    isFlatResponse: boolean = false
  ): Promise<ApiResponse<T>> {
    const me = this;
    // prepare headers
    let request_headers = {
      // reciving data as JSON
      Accept: "application/json",
      // sending data as JSON
      "Content-Type": "application/json",
    };

    // set the authorization token
    if (me.YourAppServer.Auth.IsActive) {
      request_headers["Authorization"] =
        "Bearer " + me.YourAppServer.Auth.BearerToken;
    } else {
      me.YourAppServer.coreLogService.info(
        "YourAppServerApi.RequestService",
        "RequestService: auth is not active, why is it annonym method?"
      );
    }

    // prepare headers
    // momently no parameters needs
    let request_params = null;

    // when request is external set, then extent this headers and params
    if (request !== null) {
      if (request.headers !== null) {
        request_headers = { ...request.headers, ...request_headers };
      }
      if (request.params !== null) {
        request_params = { ...request.params, ...request_params };
      }
    }

    // prepare HTTP POST Request to the API
    const req = new Request({
      baseURI: me.YourAppServer.BaseURI,
      uri: me.MainPath + apiFunction,
      method: "POST",
      headers: request_headers,
      params: request_params,
      body: body,
    });

    // wraps the Promise<Request> to Promise<ApiResponse>
    const ApiPromise = new Promise<ApiResponse<T>>((resolve, reject) => {
      // make HTTP API call
      me.YourAppServer.httpService
        .Request(req)
        .then((resp) => {
          // Prüfung: ist die session zwischenzeitig beendet worden
          /* todo vorerst das neueinloggen bei abgelaufener session ausbauen
                   bis geklärtwerden konnte, warum das Automatische ausloggen nicht richtig funktioniert
          if (!resp.ok && resp.code == 401 && resp.headers["wrong-authenticate"] == "Bearer") {
            // ein abbruch der comunication, relog as anonymus und eine umleitung auf den inital screen übernehmen
            reject(resp);
            me.YourAppServer.Auth.SignInAnonymousOrNobody().then((success) => {
              me.YourAppServer.injector.get(Router).navigateByUrl("/"); // umleitung auf home
            }).catch((error) => {
              me.YourAppServer.coreLogService.error("YourAppServerApi.RequestService", "Auth.SignOut", error);
              me.YourAppServer.injector.get(Router).navigateByUrl("/"); // umleitung auf home
            });
            return; // breake
          }
          */
          resolve(new ApiResponse<T>(responseClass, resp, isFlatResponse));
        })
        .catch((reason) => {
          reject(reason);
        });
    });
    return ApiPromise;
  }

  /** Ermittelt die DeviceID, welche als Fingerprint genutzt wird um Daten wie Likes und Kommentare für das Gerät ohne Benutzer zu Speichern */
  public GetDeviceToken(): Promise<string> {
    const me = this;
    if (me._DeviceToken != null) {
      return Promise.resolve(me._DeviceToken);
    }

    if (!me.YourAppServer.coreCOMService.environment.client.isMobile) {
      return Promise.resolve(""); // (if not mobile = browser) and browser gets no persistend DeviceID
    } else {
      return new Promise<string>((resolve /* no reject */) => {
        me.YourAppServer.coreCOMService.environment.valueStorage
          .get(StorageHive.Local, LocalKeys.yourAppDeviceToken)
          .then((value) => {
            if (!Utils.IsNull(value)) {
              me._DeviceToken = value;
              resolve(me._DeviceToken);
            } else {
              // get one from YourAppServer
              me.GetNewDeviceToken().then(resolve); // er hat kein catch
            }
          })
          .catch((error) => {
            // todo was könnte der grund für den fehler sein?
            // todo ist er ratsam beim fehler eine DeviceID zu holen?
            me.YourAppServer.coreLogService.error(
              "YourAppServerAuth.GetDeviceToken",
              "valueStorage.get",
              error
            );
            // get one from YourAppServer
            me.GetNewDeviceToken().then(resolve); // er hat kein catch
          });
      });
    }
  }

  /** Läst sich ein DeviceToken vom YourAppServer erzeugen */
  private GetNewDeviceToken(): Promise<string> {
    const me = this;
    // sollte es bereits ein Token haben, so ihn zurückgeben
    if (me._DeviceToken != null) {
      return Promise.resolve(me._DeviceToken);
    }

    // todo momentan für debug zwecke darf er das
    // // virtuelles gerät soll keine DeviceId erhalten
    // if (device.isVirtual) {
    //   return Promise.resolve(null);
    // }

    return new Promise<string>(async (resolve /* no reject */) => {
      const client = me.YourAppServer.coreCOMService.environment.client;
      const fcmToken = await me.getFcmToken();
      const language = await me.getLanguage();
      // erstelle request für ein Device Token
      const req = new Request({
        baseURI: me.YourAppServer.BaseURI,
        uri: me.YourAppServer.Api.MainPath + "account/GetDeviceToken",
        method: "POST",
        headers: {
          // reciving data as JSON
          Accept: "application/json",
        },
        body: {
          client_id: environment.YourAppServer.ClientID,
          manufacturer: client.manufacturer,
          model: client.model,
          serial: device.serial, // todo ist es notwendig?
          uuid: device.uuid, // todo ist es notwendig?
          platform: device.platform, // todo ist es notwendig?
          version: device.version, // todo ist es notwendig?
          fcm_token: fcmToken,
          language: language, // eingestellte Benutzersprache am Device
        },
      });

      // hole den deviceToken, sonst null
      me.YourAppServer.httpService
        .Request(req)
        .then((response) => {
          if (response.ok && response.body.data_type === "DeviceSuccessModel") {
            me._DeviceToken = response.body.data.device_token;
            // Abspeichern des FCMToken, für späteren vergleich
            me.YourAppServer.coreCOMService.environment.valueStorage
              .set(StorageHive.Local, LocalKeys.yourAppDeviceFCMToken, fcmToken)
              .catch((e) => {
                me.YourAppServer.coreLogService.error(
                  "YourAppServerApi.GetNewDeviceToken",
                  "environment.valueStorage.set",
                  e
                );
              });
            // Abspeichern der letzten gesendeten Sprache
            me.YourAppServer.coreCOMService.environment.valueStorage
              .set(StorageHive.Local, LocalKeys.lastSendLanguage, language)
              .catch((e) => {
                me.YourAppServer.coreLogService.error(
                  "YourAppServerApi.GetNewDeviceToken",
                  "environment.valueStorage.set",
                  e
                );
              });
            me.SaveDeviceToken()
              .then(() => {
                resolve(me._DeviceToken);
              })
              .catch((error) => {
                me.YourAppServer.coreLogService.error(
                  "YourAppServerApi.GetNewDeviceToken",
                  "SaveDeviceToken",
                  error
                );
                resolve(null);
              });
          } else {
            resolve(null);
          }
        })
        .catch((error) => {
          me.YourAppServer.coreLogService.error(
            "YourAppServerApi.GetNewDeviceToken",
            "HttpService.Request",
            error
          );
          resolve(null);
        });
    });
  }

  /** Get the Language considering the possible language choices and the previously saved value */
  public async getLanguage(): Promise<string> {
    const me = this;
    let language = InternationalisationService.locale;
    try {
      const languageSetting = (
        await me.YourAppServer.settingsService.GetSettingsMainNavDataViewModel()
      ).language;
      // Determine whether it is allowed to select the language
      if (languageSetting === "") {
        const languageChoice =
          await me.YourAppServer.coreCOMService.environment.valueStorage.get(
            StorageHive.Local,
            LocalKeys.languageChoice
          );
        if (Utils.IsNull(languageChoice)) {
          // Wert mit Standardeinstellung in der Datenbank anlegen.
          // Standard auf die Sprache der Benutzeroberfläche des Gerätes setzen.
          // that.setLanguageChoice("de");
          // Read language from navigation.language
          // and set with
          let deviceLanguage = navigator.language.toLowerCase(); // "de-DE" / "en-US"
          if (deviceLanguage.length > 2) {
            deviceLanguage = deviceLanguage.substr(0, 2);
          }
          // wenn nicht deutsch dann englisch
          if (deviceLanguage !== "de") {
            deviceLanguage = "en";
          }
          language = deviceLanguage;
        } else {
          language = languageChoice;
        }
      } else {
        language = languageSetting;
      }
    } catch (error) {
      me.YourAppServer.coreLogService.error(
        "YourAppServerApi.getLanguage",
        "getLanguageChoice",
        error
      );
    }
    return language;
  }

  public async getFcmToken(): Promise<string> {
    const me = this;

    try {
      const hasPermission = await me.YourAppServer.coreCOMService.environment.firebaseCloudMessaging.requestPermission();
      if (hasPermission) {
        return await me.YourAppServer.coreCOMService.environment.firebaseCloudMessaging.getToken();
      }
    } catch (error) {
      me.YourAppServer.coreLogService.error("YourAppServerApi.getFcmToken", "fcm.getToken", error);
    }
    return null;
  }

  /** Updated Device Informationen (FcmToken, Language)*/
  public UpdateDevice(): Promise<void> {
    const me = this;

    return new Promise<void>(async (resolve, reject) => {
      // Can't update on a non-mobile Device
      if (!me.YourAppServer.coreCOMService.environment.client.isMobile) {
        resolve();
        return;
      }

      let deviceToken = "";
      try {
        deviceToken = await me.GetDeviceToken();
      } catch (error) {
        me.YourAppServer.coreLogService.error(
          "YourAppServerAuth.UpdateDevice",
          "GetDeviceToken",
          error
        );
        reject();
        return;
      }

      let fcmToken = await me.getFcmToken();
      const language = await me.getLanguage();
      if (fcmToken == null) {
        fcmToken = await me.YourAppServer.coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.yourAppDeviceFCMToken);
      }

      // erstelle request für ein Device Token
      const req = new Request({
        baseURI: me.YourAppServer.BaseURI,
        uri: me.YourAppServer.Api.MainPath + "account/UpdateDevice",
        method: "POST",
        headers: {
          // reciving data as JSON
          Accept: "application/json",
          Authorization: "Bearer " + me.YourAppServer.Auth.BearerToken,
        },
        body: {
          client_id: environment.YourAppServer.ClientID,
          client_fingerprint: await me.GetDeviceToken(),
          version: device.version, // todo ist es notwendig?
          fcm_token: fcmToken,
          language: language, // eingestellte Benutzersprache am Device
        },
      });

      // hole den deviceToken, sonst null
      me.YourAppServer.httpService
        .Request(req)
        .then((response) => {
          if (response.ok && response.body.data_type === "DeviceSuccessModel") {
            if (deviceToken !== response.body.data.device_token) {
              me.YourAppServer.coreLogService.error(
                "YourAppServerApi.UpdateDevice",
                "Device Tokens not equal",
                deviceToken,
                response.body.data.device_token
              );
              reject();
            } else {
              // Abspeichern des FCMToken, für späteren vergleich
              if (fcmToken != null) {
                me.YourAppServer.coreCOMService.environment.valueStorage
                  .set(
                    StorageHive.Local,
                    LocalKeys.yourAppDeviceFCMToken,
                    fcmToken
                  )
                  .catch((e) => {
                    me.YourAppServer.coreLogService.error(
                      "YourAppServerApi.GetNewDeviceToken",
                      "environment.valueStorage.set",
                      e
                    );
                  });
              }

              // Abspeichern der letzten gesendeten Sprache
              me.YourAppServer.coreCOMService.environment.valueStorage
                .set(StorageHive.Local, LocalKeys.lastSendLanguage, language)
                .catch((e) => {
                  me.YourAppServer.coreLogService.error(
                    "YourAppServerApi.GetNewDeviceToken",
                    "environment.valueStorage.set",
                    e
                  );
                });
              resolve();
            }
          } else {
            reject();
          }
        })
        .catch((error) => {
          me.YourAppServer.coreLogService.error(
            "YourAppServerApi.UpdateDevice",
            "HttpService.Request",
            error
          );
          reject();
        });
    });
  }

  /** Speichert den DeviceToken in den Storage */
  private SaveDeviceToken(): Promise<void> {
    const me = this;
    return me.YourAppServer.coreCOMService.environment.valueStorage.set(
      StorageHive.Local,
      LocalKeys.yourAppDeviceToken,
      me._DeviceToken
    );
  }

  /** Email zum zurücksetzen des Passwords wird versendet
   * @param mail E-Mailadresse vom Benutzer
   */
  public ForgotPassword(mail: string): Promise<boolean> {
    const me = this;
    return new Promise<boolean>(async (resolve, reject) => {
      // prepare ForgotPassword Request
      const req = new Request({
        baseURI: me.YourAppServer.BaseURI,
        uri: me.YourAppServer.Api.MainPath + "account/ForgotPassword",
        method: "POST",
        headers: null,
        body: {
          language: InternationalisationService.locale,
          client_id: environment.YourAppServer.ClientID,
          client_fingerprint: await me.GetDeviceToken(),
          mail: mail,
        },
      });

      // führe die anfrage zum passwort zurücksetzen durch, ok sagt aus ob es funktioniert hat
      me.YourAppServer.httpService
        .Request(req)
        .then((response) => {
          if (response.ok) {
            resolve(response.body.data.success);
          } else {
            reject(response.ya_error_code); // direckte rückgabe des fehlercodes
          }
        })
        .catch((error) => {
          me.YourAppServer.coreLogService.error(
            "YourAppServerAuth.ForgotPassword",
            "HttpService.Request",
            error
          );
          reject(error);
        });
    });
  }

  /** Änderung des aktuellen Passwords, nach der durchführung wird eine eMail als bestätigung zugestellt
   * @param old_password aktuelles Password
   * @param new_password neues Password
   */
  public ChangePassword(
    old_password: string,
    new_password: string
  ): Promise<boolean> {
    const me = this;
    return new Promise<boolean>(async (resolve, reject) => {
      // prepare ChangePassword Request
      const req = new Request({
        baseURI: me.YourAppServer.BaseURI,
        uri: me.YourAppServer.Api.MainPath + "account/ChangePassword",
        method: "POST",
        headers: {
          Authorization: "Bearer " + me.YourAppServer.Auth.BearerToken,
        },
        body: {
          language: InternationalisationService.locale,
          client_id: environment.YourAppServer.ClientID,
          client_fingerprint: await me.GetDeviceToken(),
          old_password: old_password,
          new_password: new_password,
        },
      });

      // führe die anfrage zum ändern des Passwords durch, ok sagt aus ob es funktioniert hat
      me.YourAppServer.httpService
        .Request(req)
        .then((response) => {
          if (response.ok) {
            resolve(response.body.data.success);
          } else {
            reject(response.ya_error_code); // direckte rückgabe des fehlercodes
          }
        })
        .catch((error) => {
          me.YourAppServer.coreLogService.error(
            "YourAppServerAuth.ChangePassword",
            "HttpService.Request",
            error
          );
          reject(error);
        });
    });
  }

  /** Email zum verefizieren der eMail wird versendet
   * @param mail E-Mailadresse vom Benutzer
   */
  public RetryVeryfication(mail: string): Promise<boolean> {
    const me = this;
    return new Promise<boolean>(async (resolve, reject) => {
      // prepare RetryVeryfication Request
      const req = new Request({
        baseURI: me.YourAppServer.BaseURI,
        uri: me.YourAppServer.Api.MainPath + "account/RetryVeryfication",
        method: "POST",
        headers: null,
        body: {
          language: InternationalisationService.locale,
          client_id: environment.YourAppServer.ClientID,
          client_fingerprint: await me.GetDeviceToken(),
          mail: mail,
        },
      });

      // führe die anfrage zum mail bestätigen durch, ok sagt aus ob es funktioniert hat
      me.YourAppServer.httpService
        .Request(req)
        .then((response) => {
          if (response.ok) {
            resolve(response.body.data.success);
          } else {
            reject(response.ya_error_code); // direckte rückgabe des fehlercodes
          }
        })
        .catch((error) => {
          me.YourAppServer.coreLogService.error(
            "YourAppServerAuth.RetryVeryfication",
            "HttpService.Request",
            error
          );
          reject(error);
        });
    });
  }

  /** Abrufen neuester version zu der momentan verwendeten Version */
  public GetNewVersion(): Promise<VersionModel> {
    const me = this;
    return new Promise<VersionModel>(async (resolve, reject) => {
      // prepare GetNewVersion Request
      const req_data = new GetNewVersionModel();
      req_data.version = appConfig.version;
      req_data.platform =
        me.YourAppServer.coreCOMService.environment.client.platform;

      const req = new Request({
        baseURI: me.YourAppServer.BaseURI,
        uri: me.YourAppServer.Api.MainPath + "version/GetNewVersion",
        method: "POST",
        headers: null,
        body: req_data,
      });

      // rufe die neue version ab
      me.YourAppServer.httpService
        .Request(req)
        .then((response) => {
          if (response.ok) {
            resolve(Utils.GetExtend(new VersionModel(), response.body.data));
          } else {
            reject(response.ya_error_code); // direckte rückgabe des fehlercodes
          }
        })
        .catch((error) => {
          me.YourAppServer.coreLogService.error(
            "YourAppServerAuth.GetNewVersion",
            "HttpService.Request",
            error
          );
          reject(error);
        });
    });
  }

  /**
   * Find the near zipcode to the geolocation
   * @param latlng like '53.602961,10.157586'
   */
  public GetZipFromGeolocation(latlng: string): Promise<string> {
    const me = this;
    return new Promise<string>(async (resolve, reject) => {
      // prepare RetryVeryfication Request
      const req = new Request({
        baseURI: me.YourAppServer.BaseURI,
        uri: me.YourAppServer.Api.MainPath + "location/GetZipFromGeolocation",
        method: "POST",
        headers: null,
        body: {
          latlng: latlng,
        },
      });

      me.YourAppServer.httpService
        .Request(req)
        .then((response) => {
          if (response.ok) {
            resolve(response.body.data.zip);
          } else {
            reject(response.ya_error_code); // direckte rückgabe des fehlercodes
          }
        })
        .catch((error) => {
          me.YourAppServer.coreLogService.error(
            "YourAppServerAuth.GetZipFromGeolocation",
            "HttpService.Request",
            error
          );
          reject(error);
        });
    });
  }

  /** Submits a revoke-order declaration (guest-accessible).
   *  @returns Promise<boolean> — true when server confirms receipt (data.success). */
  public SubmitRevokeOrder(params: {
    name: string;
    email: string;
    order_number: string;
    articles: string | null;
    reason: string | null;
  }): Promise<boolean> {
    const me = this;
    return new Promise<boolean>(async (resolve, reject) => {
      const req = new Request({
        baseURI: me.YourAppServer.BaseURI,
        uri: me.YourAppServer.Api.MainPath + "order/SubmitRevokeOrder",
        method: "POST",
        headers: null,
        body: {
          language: InternationalisationService.locale,
          client_id: environment.YourAppServer.ClientID,
          client_fingerprint: await me.GetDeviceToken(),
          name: params.name,
          email: params.email,
          order_number: params.order_number,
          articles: params.articles,
          reason: params.reason,
        },
      });
      me.YourAppServer.httpService
        .Request(req)
        .then((response) => {
          if (response.ok) {
            resolve(response.body.data.success);
          } else {
            reject(response.ya_error_code);
          }
        })
        .catch((error) => {
          me.YourAppServer.coreLogService.error(
            "YourAppServerApi.SubmitRevokeOrder",
            "HttpService.Request",
            error
          );
          reject(error);
        });
    });
  }
}
